module.exports = __webpack_public_path__ + "eca9d0015f6222ebfe373fad51a89da7.png";


//////////////////
// WEBPACK FOOTER
// ./src/theme/images/icons/person-dark.png
// module id = 128
// module chunks = 0 4 5 6 10 29